import React, { useMemo } from 'react';

import { Badge } from '@mui/material';
import { IconArrowRightToArc } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';

import { DropDownMenu } from '@/components/lists/DropDownMenu';
import { DropDownMenuItem } from '@/components/lists/DropDownMenu/DropDownMenu.types';
import { useSignout } from '@/features/auth/hooks/useSignout';
import { useAuthStore } from '@/features/auth/stores/useAuthStore';
import { useUserMarketRoles } from '@/features/markets/hooks/useUserMarketRoles';

import { SessionNavAvatar } from './SessionNavAvatar';

export const NavSelectorUser = () => {
    const { t } = useTranslation();
    const { authUser } = useAuthStore();

    const { signout } = useSignout();
    const { getUserMarketRoles } = useUserMarketRoles();

    const title = useMemo(() => authUser?.fullName, [authUser?.fullName]);

    const subtitle = useMemo(() => `${t('role')}: ${getUserMarketRoles(authUser)}`, [t, authUser, getUserMarketRoles]);

    const items: DropDownMenuItem[] = useMemo(
        () => [{ id: 'logout', icon: <IconArrowRightToArc />, label: t('logout'), action: () => signout() }],
        [t, signout],
    );

    return (
        <DropDownMenu id="userselector" title={title} subtitle={subtitle} items={items}>
            <Badge
                role="button"
                overlap="circular"
                sx={{ '> .MuiBadge-badge': { pointerEvents: 'none' } }}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
            >
                <SessionNavAvatar>
                    <span style={{ transform: 'translateY(1px)' }}>{authUser?.initialsName}</span>
                </SessionNavAvatar>
            </Badge>
        </DropDownMenu>
    );
};
